import { render, staticRenderFns } from "./VideoLink.vue?vue&type=template&id=4d5ada52&scoped=true"
import script from "./VideoLink.vue?vue&type=script&lang=ts"
export * from "./VideoLink.vue?vue&type=script&lang=ts"
import style0 from "./VideoLink.scss?vue&type=style&index=0&id=4d5ada52&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ada52",
  null
  
)

export default component.exports